import { useEffect, useState } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { AccentProvider } from './context/AccentContext';
import { AppShell } from './components/layout/AppShell';
import { LoginPage } from './pages/LoginPage';
import { AccueilPage } from './pages/AccueilPage';
import { SalairesPage } from './pages/SalairesPage';
import { RevenusPage } from './pages/RevenusPage';
import { MesuresPage } from './pages/MesuresPage';
import { LoyersPage } from './pages/LoyersPage';
import { ClientsPage } from './pages/ClientsPage';
import { ContratsPage } from './pages/ContratsPage';
import { PrestationsPage } from './pages/PrestationsPage';
import { BudgetPage } from './pages/BudgetPage';
import { ChargesPage } from './pages/ChargesPage';
import { RHPage } from './pages/RHPage';
import { CoutAteliersPage } from './pages/CoutAteliersPage';
import { ScenariosPage } from './pages/ScenariosPage';
import { AdminPage } from './pages/AdminPage';
import { ProfilPage } from './pages/ProfilPage';
import { NotificationsPage } from './pages/NotificationsPage';

export type Page = 'accueil' | 'budget' | 'salaires' | 'rh' | 'coutateliers' | 'charges' | 'scenarios' | 'revenus' | 'mesures' | 'loyers' | 'clients' | 'contrats' | 'prestations' | 'admin' | 'profil' | 'notifications';

const PAGES: Page[] = ['accueil', 'budget', 'salaires', 'rh', 'coutateliers', 'charges', 'scenarios', 'revenus', 'mesures', 'loyers', 'clients', 'contrats', 'prestations', 'admin', 'profil', 'notifications'];

function pageFromHash(): Page {
  const hash = window.location.hash.replace(/^#/, '').split('?')[0];
  return (PAGES as string[]).includes(hash) ? (hash as Page) : 'accueil';
}

function AppContent() {
  const { user, loading, isAdmin } = useAuth();
  const [page, setPage] = useState<Page>(pageFromHash);

  useEffect(() => {
    const onHashChange = () => setPage(pageFromHash());
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center" style={{ height: '100vh' }}>
        <div className="spinner" />
      </div>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  const effectivePage: Page = page === 'admin' && !isAdmin ? 'accueil' : page;

  const navigate = (p: Page) => {
    window.location.hash = p;
  };

  return (
    <AppShell currentPage={effectivePage} onNavigate={navigate}>
      {effectivePage === 'accueil' && <AccueilPage />}
      {effectivePage === 'salaires' && <SalairesPage />}
      {effectivePage === 'revenus' && <RevenusPage />}
      {effectivePage === 'mesures' && <MesuresPage />}
      {effectivePage === 'loyers' && <LoyersPage />}
      {effectivePage === 'clients' && <ClientsPage />}
      {effectivePage === 'contrats' && <ContratsPage />}
      {effectivePage === 'prestations' && <PrestationsPage />}
      {effectivePage === 'budget' && <BudgetPage />}
      {effectivePage === 'charges' && <ChargesPage />}
      {effectivePage === 'rh' && <RHPage />}
      {effectivePage === 'coutateliers' && <CoutAteliersPage />}
      {effectivePage === 'scenarios' && <ScenariosPage />}
      {effectivePage === 'admin' && <AdminPage />}
      {effectivePage === 'profil' && <ProfilPage />}
      {effectivePage === 'notifications' && <NotificationsPage />}
    </AppShell>
  );
}

export function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AccentProvider>
          <AppContent />
        </AccentProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
